import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { transformKeysToCamelCase } from '../../utils/caseTransformers';
import { isAirgappedMode } from '../../utils/env';
import { isAuthenticatedPage } from '../../utils/url';
import {
  GetUserResponse,
  User,
} from '../httpClients/PlatformClient/api.schema';
import { PlatformClient } from '../httpClients/PlatformClient/PlatformClient';
import { QUERY_KEYS } from './consts';

type OmittedQueryOptions = Omit<
  UseQueryOptions<GetUserResponse>,
  'queryKey' | 'queryFn' | 'select'
>;
export const useUserQuery = (queryOptions: OmittedQueryOptions = {}) =>
  useQuery({
    queryKey: [QUERY_KEYS.USER],
    queryFn: PlatformClient.getUser,
    select: (data): User => transformKeysToCamelCase(data.user),
    enabled: isAuthenticatedPage() && !isAirgappedMode(),
    ...queryOptions,
  });
